import { render, staticRenderFns } from "./GroupComment.vue?vue&type=template&id=7642044f&scoped=true"
import script from "./GroupComment.vue?vue&type=script&lang=js"
export * from "./GroupComment.vue?vue&type=script&lang=js"
import style0 from "./GroupComment.vue?vue&type=style&index=0&id=7642044f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7642044f",
  null
  
)

export default component.exports